export default __webpack_public_path__ + "static/media/logo_healthid_ex_g.4e52c281.png";